import Swiper from 'swiper'
import { Navigation } from 'swiper/modules'

export default class HeroSlider {
  constructor(el) {
    this.el = el
    this.init()
  }

  init() {
    const speed = 600

    const swiperSecondary = new Swiper(this.el.querySelector('.hero-slider--slider-secondary'), {
      slidesPerView: 1,
      initialSlide: 1,
      loop: true,
      allowTouchMove: false,
      speed,
    })

    const swiperPrimary = new Swiper(this.el.querySelector('.hero-slider--slider-main'), {
      modules: [Navigation],
      slidesPerView: 1,
      speed,
      loop: true,
      longSwipesRatio: 0.01,
      watchSlidesProgress: true,
      navigation: {
        nextEl: this.el.querySelector('.swiper-button-next'),
        prevEl: this.el.querySelector('.swiper-button-prev'),
      },
    })

    swiperPrimary.on('slideNextTransitionStart', () => swiperSecondary.slideNext())
    swiperPrimary.on('slidePrevTransitionStart', () => swiperSecondary.slidePrev())
  }
}
